module.exports = "<div *ngFor=\"let child of category\">\r\n    <config-prop [prop]=\"child\"></config-prop>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Development/Angular/grim3212.com/src/app/containers/grim-pack/config/config.component.html
// module id = ../../../../../src/app/containers/grim-pack/config/config.component.html
// module chunks = main